import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { unsafeHTML as o } from '../../../../node_modules/lit-html/directives/unsafe-html.js';
import { ifDefined as l } from '../../../../node_modules/lit-html/directives/if-defined.js';
import '../../atoms/buttons/enums.js';
import { isRTL, wrapRichTextTables } from '../../utilities/dom-helpers/index.js';
import { buildPaddingInlineStyle } from '../../utilities/spacing-helpers/index.js';
import { MediaTypes, TextAlignmentTypes, MediaAlignmentTypes, TitleAlignmentTypes, VideoTypes } from './types.js';
import '../../atoms/generic-image/index.js';
import '../../atoms/buttons/generic-button2.0/index.js';
import '../video-block/index.js';
import '../../molecules/video-player-plus/index.js';
import css_248z from './text-media-block.scss.js';
import { StyleTypes } from '../text-block/types.js';

class TextMediaBlock extends s {
    constructor() {
        super(...arguments);
        this.styleType = StyleTypes.GREY;
        this.mediaType = MediaTypes.NONE;
        this.textAlignment = TextAlignmentTypes.CENTER;
        this.mediaAlignment = MediaAlignmentTypes.LEFT;
        this.titleAlignment = TitleAlignmentTypes.CENTER;
        this.rtl = false;
        this.richTextContent = '';
        this.utilityClasses = '';
        this.useSlot = false;
        this.primaryCta = null;
        this.secondaryCta = null;
        // Image props
        this.imageSrc = '';
        this.imageAlt = '';
        this.imageCaption = '';
        this.imageDecorative = false;
        // Video props - Thumbnail
        this.videoThumbnailSrc = '';
        this.videoThumbnailAlt = '';
        // Video props - Player
        this.videoId = '';
        this.videoName = '';
        this.videoTitleText = '';
        this.videoType = VideoTypes.YOUTUBE;
        // Video props - Accessibility
        this.videoButtonAriaLabel = 'Play video';
        this.videoCloseButtonText = 'Close';
        this.videoClosedCaptionsUrl = '';
        this.videoClosedCaptionsLang = '';
        this.videoAudioDescriptionUrl = '';
        this.videoAudioDescriptionLang = '';
        // Video props - Caption
        this.videoCaption = '';
    }
    static toUndefinedIfEmpty(value) {
        return value.trim() === '' ? undefined : value;
    }
    get hasMedia() {
        return this.mediaType !== MediaTypes.NONE;
    }
    get hasCtas() {
        return this.primaryCta !== null || this.secondaryCta !== null;
    }
    get isRtlMode() {
        return this.rtl || isRTL();
    }
    get articleClasses() {
        return [
            'text-media-block',
            `style-${this.styleType}`,
            this.hasMedia ? `align-media-${this.mediaAlignment}` : 'no-media',
            !this.hasMedia && this.textAlignment && `text-align-${this.textAlignment}`,
            !this.hasMedia && this.titleAlignment && `title-align-${this.titleAlignment}`,
            this.isRtlMode && 'rtl',
            this.utilityClasses,
        ]
            .filter(Boolean)
            .join(' ');
    }
    get buttonStyleType() {
        return this.styleType === StyleTypes.BUERGENDY ||
            this.styleType === StyleTypes.PURPLE
            ? 'dark'
            : 'light';
    }
    get buttonColor() {
        return this.styleType === StyleTypes.BUERGENDY ? 'burgundy' : 'purple';
    }
    connectedCallback() {
        super.connectedCallback();
    }
    firstUpdated() {
        var _a, _b;
        if (this.sectionTitle) {
            this._headingId = this.generateUniqueId();
        }
        if (document.querySelector('parallax-bg')) {
            (_b = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.text-media-block')) === null || _b === void 0 ? void 0 : _b.classList.add('remove-bg');
        }
        this.preventIncorrectClickBehavior();
    }
    preventIncorrectClickBehavior() {
        const article = this.shadowRoot.querySelector('.text-media-block');
        if (!article)
            return;
        article.addEventListener('click', (e) => {
            const target = e.target;
            if (target.closest('a') || target.closest('button') || target.closest('generic-button-updated')) {
                e.stopPropagation();
                return;
            }
            e.stopPropagation();
        });
    }
    generateUniqueId() {
        const sanitizedTitle = this.sectionTitle
            .toLowerCase()
            .replace(/\s+/g, '-')
            .replace(/[^a-z0-9-]/g, '');
        return `${sanitizedTitle}-${crypto.randomUUID()}`;
    }
    renderBlockTitle() {
        const titleClass = `block-title title-align-${this.titleAlignment}`;
        return this.sectionTitle
            ? $ `<h2 id="${l(this._headingId)}" class="${titleClass}">${o(this.sectionTitle)}</h2>`
            : '';
    }
    renderImage() {
        return $ `<generic-image src="${l(TextMediaBlock.toUndefinedIfEmpty(this.imageSrc))}" alt="${l(TextMediaBlock.toUndefinedIfEmpty(this.imageAlt))}" caption="${l(TextMediaBlock.toUndefinedIfEmpty(this.imageCaption))}" aspect-ratio="16:9" loading="lazy" decorative="${l(this.imageDecorative ? 'decorative' : undefined)}"></generic-image>`;
    }
    renderVideo() {
        return $ `<video-block styleType="${this.styleType}" buttonAriaLabel="${l(TextMediaBlock.toUndefinedIfEmpty(this.videoButtonAriaLabel))}" layout="below"><img slot="thumbnail" src="${l(TextMediaBlock.toUndefinedIfEmpty(this.videoThumbnailSrc))}" alt="${l(TextMediaBlock.toUndefinedIfEmpty(this.videoThumbnailAlt))}" loading="lazy"> ${this.renderVideoTitle()}<video-player-plus slot="lightbox-video" videoId="${l(TextMediaBlock.toUndefinedIfEmpty(this.videoId))}" videoName="${l(TextMediaBlock.toUndefinedIfEmpty(this.videoName))}" type="${this.videoType}" ?isLightbox="${true}" closeButtonText="${l(TextMediaBlock.toUndefinedIfEmpty(this.videoCloseButtonText))}" closedCaptions="${l(TextMediaBlock.toUndefinedIfEmpty(this.videoClosedCaptionsUrl))}" closedCaptionsLang="${l(TextMediaBlock.toUndefinedIfEmpty(this.videoClosedCaptionsLang))}" audioDescription="${l(TextMediaBlock.toUndefinedIfEmpty(this.videoAudioDescriptionUrl))}" audioDescriptionLang="${l(TextMediaBlock.toUndefinedIfEmpty(this.videoAudioDescriptionLang))}"></video-player-plus>${this.renderVideoCaption()}</video-block>`;
    }
    renderVideoCaption() {
        return this.videoCaption
            ? $ `<span slot="caption">${o(this.videoCaption)}</span>`
            : '';
    }
    renderVideoTitle() {
        return this.videoTitleText
            ? $ `<span slot="text">${this.videoTitleText}</span>`
            : '';
    }
    renderMediaContainer() {
        return this.hasMedia
            ? $ `<div class="media-container">${this.mediaType === MediaTypes.IMAGE ? this.renderImage() : ''} ${this.mediaType === MediaTypes.VIDEO ? this.renderVideo() : ''}</div>`
            : '';
    }
    renderRichText() {
        const styleClass = `style-${this.styleType}`;
        const rteClasses = `rte${this.isRtlMode ? ' rte--rtl' : ''}`;
        if (this.useSlot) {
            return $ `<slot name="rich-text"></slot>`;
        }
        return $ `<div class="rich-text transparent ${styleClass} ${rteClasses}">${o(wrapRichTextTables(this.richTextContent))}</div>`;
    }
    renderCta(cta, type) {
        const target = cta.target || '_self';
        const distinctAriaLabel = cta.ariaLabel && cta.ariaLabel !== cta.title ? cta.ariaLabel : undefined;
        return $ `<generic-button-updated type="${type}" .color="${this.buttonColor}" .styleType="${this.buttonStyleType}" label="${cta.title}" href="${cta.url}" target="${target}" ?isNoFollow="${cta.isNoFollow || false}" ?rtl="${this.isRtlMode}" .ariaList="${distinctAriaLabel ? { label: distinctAriaLabel } : {}}"></generic-button-updated>`;
    }
    renderCtas() {
        if (!this.hasCtas) {
            return '';
        }
        return $ `<div class="cta-container" role="group" aria-label="Actions">${this.primaryCta ? this.renderCta(this.primaryCta, 'primary') : ''} ${this.secondaryCta
            ? this.renderCta(this.secondaryCta, 'secondary')
            : ''}</div>`;
    }
    render() {
        const direction = this.isRtlMode ? 'rtl' : 'ltr';
        const spacingStyle = buildPaddingInlineStyle(this.utilityClasses);
        return $ `<section class="text-media-group" aria-labelledby="${l(this._headingId)}"><article class="${this.articleClasses}" style="${l(spacingStyle)}" dir="${direction}">${this.renderMediaContainer()}<div class="content-container">${this.renderBlockTitle()} ${this.renderRichText()} ${this.renderCtas()}</div></article></section>`;
    }
}
TextMediaBlock.styles = css_248z;
__decorate([
    e({ type: String })
], TextMediaBlock.prototype, "styleType", void 0);
__decorate([
    e({ type: String })
], TextMediaBlock.prototype, "mediaType", void 0);
__decorate([
    e({ type: String })
], TextMediaBlock.prototype, "textAlignment", void 0);
__decorate([
    e({ type: String })
], TextMediaBlock.prototype, "mediaAlignment", void 0);
__decorate([
    e({ type: String })
], TextMediaBlock.prototype, "titleAlignment", void 0);
__decorate([
    e({ type: Boolean })
], TextMediaBlock.prototype, "rtl", void 0);
__decorate([
    e({ type: String })
], TextMediaBlock.prototype, "sectionTitle", void 0);
__decorate([
    e({ type: String })
], TextMediaBlock.prototype, "richTextContent", void 0);
__decorate([
    e({ type: String })
], TextMediaBlock.prototype, "utilityClasses", void 0);
__decorate([
    e({ type: Boolean, reflect: true })
], TextMediaBlock.prototype, "useSlot", void 0);
__decorate([
    e({ type: Object })
], TextMediaBlock.prototype, "primaryCta", void 0);
__decorate([
    e({ type: Object })
], TextMediaBlock.prototype, "secondaryCta", void 0);
__decorate([
    e({ type: String })
], TextMediaBlock.prototype, "imageSrc", void 0);
__decorate([
    e({ type: String })
], TextMediaBlock.prototype, "imageAlt", void 0);
__decorate([
    e({ type: String })
], TextMediaBlock.prototype, "imageCaption", void 0);
__decorate([
    e({ type: Boolean })
], TextMediaBlock.prototype, "imageDecorative", void 0);
__decorate([
    e({ type: String })
], TextMediaBlock.prototype, "videoThumbnailSrc", void 0);
__decorate([
    e({ type: String })
], TextMediaBlock.prototype, "videoThumbnailAlt", void 0);
__decorate([
    e({ type: String })
], TextMediaBlock.prototype, "videoId", void 0);
__decorate([
    e({ type: String })
], TextMediaBlock.prototype, "videoName", void 0);
__decorate([
    e({ type: String })
], TextMediaBlock.prototype, "videoTitleText", void 0);
__decorate([
    e({ type: String })
], TextMediaBlock.prototype, "videoType", void 0);
__decorate([
    e({ type: String })
], TextMediaBlock.prototype, "videoButtonAriaLabel", void 0);
__decorate([
    e({ type: String })
], TextMediaBlock.prototype, "videoCloseButtonText", void 0);
__decorate([
    e({ type: String })
], TextMediaBlock.prototype, "videoClosedCaptionsUrl", void 0);
__decorate([
    e({ type: String })
], TextMediaBlock.prototype, "videoClosedCaptionsLang", void 0);
__decorate([
    e({ type: String })
], TextMediaBlock.prototype, "videoAudioDescriptionUrl", void 0);
__decorate([
    e({ type: String })
], TextMediaBlock.prototype, "videoAudioDescriptionLang", void 0);
__decorate([
    e({ type: String })
], TextMediaBlock.prototype, "videoCaption", void 0);
__decorate([
    t()
], TextMediaBlock.prototype, "_headingId", void 0);
customElements.define('text-media-block', TextMediaBlock);

export { TextMediaBlock };
